// @flow
import * as React from 'react';
import Image, {BackgroundImage, checkImageExists, type Props, type PropsBackgroundImage} from 'components/Image';
import Settings from 'config/Settings';

export function getLocalizedFileName(source: string):string {
  const extIndex = source?.lastIndexOf('.') ?? -1;
  const filename = source?.substring(0, extIndex) ?? "";
  const ext = source?.substring(extIndex + 1, source.length) ?? "";
  const localizedFile = `${filename}-${Settings.localKey}.${ext}`
  if (checkImageExists(localizedFile)) {
    
    return localizedFile;
  } else {
    console.warn("LocalizedImage file not found:", localizedFile);
  }
  return source;
}

export default function LocalizedImage(props: Props): React.Element<any> {
  const {source, ...other} = props;

  const localizedSource = React.useMemo(() => {
    return getLocalizedFileName(source);
  }, [source])
  
  return (
    <Image {...other} source={localizedSource} />
  );
}

export function LocalizedBackgroundImage(props: PropsBackgroundImage): React.Element<any> {
  const {source, ...other} = props;

  const localizedSource = React.useMemo(() => {
    const extIndex = source?.lastIndexOf('.') ?? -1;
    const filename = source?.substring(0, extIndex) ?? "";
    const ext = source?.substring(extIndex + 1, source.length) ?? "";

    const localizedFile = `${filename}-${Settings.localKey}.${ext}`
    if (checkImageExists(localizedFile)) {
      return localizedFile;
    }
    
    return source;
  }, [source])
  
  return (
    <BackgroundImage {...other} source={localizedSource} ></BackgroundImage>
  );
}
